.Container {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
}

.FormRow {
  flex: 0 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.FormColumn {
  width: 100%;
  flex: 0 0 auto;
  display: flex;
  flex-direction: row;
}

.Children {
  flex: 1 1 auto;
}

.Input {
  flex: 1 1 auto;
  min-width: 5ch;
  max-width: 15ch;
}

.Spacer {
  flex: 1;
}

.Modal {
  position: absolute;
  top: 50%;
  left: 50%;
  padding: 1rem 1.5rem;
  transform: translate(-50%, -50%);
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 1rem;
  border: 2px solid black;
  user-select: none;
  text-align: center;
}
